module.exports = __webpack_public_path__ + "assets/political.2401bec8.svg";